import { render, staticRenderFns } from "./DeleteCriteria.vue?vue&type=template&id=05543ab4&scoped=true"
import script from "./DeleteCriteria.vue?vue&type=script&lang=js"
export * from "./DeleteCriteria.vue?vue&type=script&lang=js"
import style0 from "./DeleteCriteria.vue?vue&type=style&index=0&id=05543ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05543ab4",
  null
  
)

export default component.exports